import { pr, ui } from "aaa";
import { themeColors } from "muiTheme";
import * as React from "react";

export const GeorgeIdBanner = ({ onClick, style }: { onClick: () => void; style?: React.CSSProperties }) => {
    return (
        <div
            style={{
                display: "flex",
                gap: 16,
                borderRadius: 8,
                padding: 12,
                cursor: "pointer",
                backgroundColor: themeColors.blue_300,
                ...style
            }}
            role="button"
            onClick={onClick}
        >
            <img src={require("assets/georgeIdBannerLogo.svg")} />
            <div>
                <pr.P_16_TITLE style={{ color: "white", fontWeight: 600 }}>
                    {ui.__("sidentitySettings.georgeIdBanner.title")}
                </pr.P_16_TITLE>
                <pr.P_14_CONTENT style={{ color: "white", marginTop: 6 }}>
                    {ui.__("sidentitySettings.georgeIdBanner.text")}
                </pr.P_14_CONTENT>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/loginManagement/components/GeorgeIdBanner.tsx